import { Tag, Text } from '@ekhodealer/ekho-common/rev';

/**
 * Map financing status to Tag accent color
 */
const getFinancingStatusAccent = (
	status: string | undefined,
): 'neutral' | 1 | 2 | 3 | 4 | 5 | 6 | 7 => {
	if (!status) return 'neutral';

	const normalizedStatus = status.toLowerCase();

	switch (normalizedStatus) {
		case 'some lenders accepted':
		case 'buyer accepted some offer':
		case 'buyer accepted an offer':
			return 3; // Teal/Green
		case 'all lenders rejected':
		case 'buyer rejected all offers':
			return 4; // Pink/Red
		case 'awaiting lender decisions':
			return 6; // Yellow
		case 'paused':
			return 'neutral'; // Grey
		default:
			return 'neutral';
	}
};

interface FinancingStatusTagProps {
	status?: string;
}

/**
 * Shared component for rendering financing status as a Tag or "N/A" text.
 * Can be used in both table cells (with popover) and detail sections (without popover).
 */
export const FinancingStatusTag = ({ status }: FinancingStatusTagProps) => {
	// If status is null/empty, show "N/A" as text instead of a tag
	if (!status) {
		return (
			<div style={{ minWidth: '140px' }}>
				<Text size='bodySmall' color='secondary' isItalic>
					N/A
				</Text>
			</div>
		);
	}

	const accent = getFinancingStatusAccent(status);

	return <Tag size='medium' accent={accent} children={status} />;
};
